// Remove curtain on page load
function init() {
  const curtain = document.getElementById('curtain');

  if (curtain) {
    window.addEventListener('load', () => {
      curtain.classList.add('hide');
      curtain.classList.remove('show');
    });
  }
}

(() => {
  init();
})();
